import { useCallback, useEffect, useRef, useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { LeadService} from "../../../../services/LeadService";
import moment from "moment";

moment.locale('es');


export const useCalculateRiskLead = (changeAlert: ChangeAlertCallbackType, config) => {

    const [loading, setLoading] = useState(false);
    const leadService = useRef<LeadService>();

    const calculateRisk = async (leadUuid: string) => {
        setLoading(true);

        const resp = await leadService.current.calculateRiskLevel({
            leadUuid: leadUuid,
        })
        setLoading(false);

        if(resp?.data?.response ==='OK'){
            changeAlert(true,"OK", "Nivel de riesgo calculado.");
        }
        // console.log("Data: ", response.data?.content?.details)
    };
    
    const canCalculateRisk = useCallback((lead) => {
        return config?.actions?.indexOf(lead?.responsible) > -1;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    
    useEffect(() => {
        leadService.current = new LeadService(changeAlert)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return { calculateRisk,canCalculateRisk, loading }
}
